(function () {
  if (window.__pdpQtyGuard) return;
  window.__pdpQtyGuard = true;

  // --- helpers ---
  function minOf(i){ return parseInt(i.min || '1', 10); }
  function maxOf(i){
    // bevorzugt data-max; sonst HTML max; sonst "unendlich"
    const dm = parseInt(i.dataset.max || '', 10);
    if (!isNaN(dm)) return dm;
    const a = parseInt(i.getAttribute('max') || '', 10);
    return isNaN(a) ? Infinity : a;
  }
  function clamp(i, v){
    const min = minOf(i), max = maxOf(i);
    v = parseInt(v, 10);
    if (isNaN(v)) v = min;
    if (v < min) v = min;
    if (v > max) v = max;
    return v;
  }
  function setValidMsg(i, v){
    const min = minOf(i), max = maxOf(i);
    let msg = '';
    if (isNaN(v))        msg = 'Bitte eine Zahl eingeben.';
    else if (v < min)    msg = `Mindestens ${min} Stück.`;
    else if (v > max)    msg = `Nur bis ${max} Stück möglich.`;
    i.setCustomValidity(msg);
    if (msg) i.reportValidity();
  }

  // PDP-Qty finden
  const qty = document.querySelector(
    'form[action*="/cart/add"] input[type="number"], form[action*="/cart/add"] input[name="quantity"]'
  );
  if (!qty) return;

  // --- 1) Live-Validierung beim Tippen (kein Clamping) ---
  qty.addEventListener('input', () => {
    // nur Ziffern zulassen
    const digits = qty.value.replace(/\D/g, '');
    if (digits !== qty.value) qty.value = digits;

    if (!digits) { qty.setCustomValidity(''); return; }
    const v = parseInt(digits, 10);
    setValidMsg(qty, v);
  }, true);

  // --- 2) Auf blur/change -> hart klemmen + Validität leeren ---
  function clampOnCommit(){
    const v = clamp(qty, qty.value);
    qty.value = String(v);
    qty.setCustomValidity(''); // nach dem Klemmen ist es gültig
  }
  qty.addEventListener('blur',   clampOnCommit, true);
  qty.addEventListener('change', clampOnCommit, true);

  // --- 3) Plus/Minus: exakt 1 Schritt, andere Handler blocken ---
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.quantity .plus, .quantity .minus');
  if (!btn) return;

  // Event sofort „übernehmen“, damit kein zweiter Handler läuft
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();

  const wrap = btn.closest('.quantity');
  const i = wrap?.querySelector('input[type="number"], input[name="quantity"]');
  if (i !== qty) return;

  const min  = minOf(qty);
  const max  = maxOf(qty);
  const step = parseInt(qty.step || '1', 10) || 1;

  // erst auf gültigen Bereich klemmen, dann genau +/- step
  let v = clamp(qty, qty.value);
  v = btn.classList.contains('plus') ? Math.min(v + step, max)
                                     : Math.max(v - step, min);

  qty.setCustomValidity('');
  qty.value = String(v);

  // falls etwas auf Änderungen reagiert (Preis etc.)
  qty.dispatchEvent(new Event('input',  { bubbles: true }));
  qty.dispatchEvent(new Event('change', { bubbles: true }));
}, true);

  // --- 4) Enter blocken (kein sofortiges Submit) ---
  qty.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); qty.blur(); }
  }, true);
})();